window.addEventListener('DOMContentLoaded', () => {
  // DOM 요소 캐싱 및 존재 여부 확인
  const $homeFeatures = document.getElementById('homeFeatures');
  if (!$homeFeatures) return;

  // 라이브러리 존재 여부 확인
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' || typeof lottie === 'undefined') {
    console.warn('Required libraries (GSAP, ScrollTrigger, Lottie) not loaded for features');
    return;
  }



  const $header = $homeFeatures.querySelector('.features-header');
  const $features = $homeFeatures.querySelector('.features');
  const $motion = $features?.querySelector('.__motion');
  const $bg1 = $homeFeatures.querySelector('.__bg1 .__img');
  const $bg2 = $homeFeatures.querySelector('.__bg2 .__img');

  // 필수 요소 존재 확인
  if (!$header || !$features || !$motion || !$bg1 || !$bg2) {
    console.warn('Required DOM elements not found for features animation');
    return;
  }

  const $bg1Img = $bg1.querySelector('img');
  const $bg2Img = $bg2.querySelector('img');
  const $feature1 = $features.querySelector('.feature1');
  const $feature2 = $features.querySelector('.feature2');

  // 애니메이션 요소 캐싱
  const $bg1AnimContainer = $bg1.querySelector('.__anim');
  const $bg2AnimContainer = $bg2.querySelector('.__anim');

  let bg1Anim = null;
  let bg2Anim = null;

  // Lottie 애니메이션 로드 (에러 핸들링 포함)
  try {
    if (!window.prefersReducedMotion && $bg1AnimContainer) {
      bg1Anim = lottie.loadAnimation({
        container: $bg1AnimContainer,
        renderer: 'canvas',
        loop: false,
        autoplay: false,
        path: window.cPath + '/assets/lottie/line-blue.json'
      });
    }

    // if (!prefersReducedMotion && $bg2AnimContainer) {
    //   bg2Anim = lottie.loadAnimation({
    //     container: $bg2AnimContainer,
    //     renderer: 'canvas',
    //     loop: false,
    //     autoplay: false,
    //     path: window.cPath + '/assets/lottie/line-blue.json'
    //   });
    // }
  } catch (error) {
    console.warn('Lottie animation loading failed:', error);
  }

  // 초기 상태 설정 (에러 핸들링 포함)
  try {
    gsap.set($bg2, {clipPath: 'inset(100% 0% 0% 0%)'});
    gsap.set($bg2Img, {yPercent: 10, scale: 1});
    gsap.set($feature2, {yPercent: 100});

    // Feature 1 요소들 초기화
    const $feature1Txt = $feature1?.querySelector('.__title strong span');
    const $feature1Anims = $feature1?.querySelectorAll('[data-anim]');
    if ($feature1Txt) gsap.set($feature1Txt, {yPercent: 120});
    if ($feature1Anims) gsap.set($feature1Anims, {y: '5rem', opacity: 0});

    // Feature 2 요소들 초기화
    const $feature2Txt = $feature2?.querySelector('.__title strong span');
    const $feature2Anims = $feature2?.querySelectorAll('[data-anim]');
    if ($feature2Txt) gsap.set($feature2Txt, {yPercent: 120});
    if ($feature2Anims) gsap.set($feature2Anims, {y: '5rem', opacity: 0});

  } catch (error) {
    console.warn('Initial animation setup failed:', error);
    return;
  }

  // 성능 최적화된 배경 업데이트 함수
  const updateBg1In = (() => {
    let lastProgress = -1;

    return (progress) => {
      // 중복 계산 방지
      if (Math.abs(progress - lastProgress) < 0.001) return;
      lastProgress = progress;

      try {
        const startWidth = $header.clientWidth || window.innerWidth * 0.8;
        const endWidth = window.innerWidth;
        const newWidth = startWidth + (endWidth - startWidth) * progress;
        const endHeight = window.innerHeight;
        const startHeight = endHeight * 0.5;
        const newHeight = startHeight + (endHeight - startHeight) * progress;

        gsap.set($bg1, {
          width: newWidth,
          height: newHeight,
        });
        gsap.set($bg1Img, {
          scale: 2 - progress,
        });
      } catch (error) {
        console.warn('Background update failed:', error);
      }
    };
  })();

  // ScrollTrigger 생성 (에러 핸들링 포함)
  try {
    // 첫 번째 ScrollTrigger - 배경 확장
    ScrollTrigger.create({
      trigger: $features,
      start: 'top center',
      end: 'top top',
      onUpdate: (self) => {
        updateBg1In(self.progress);
      },
      onLeave: () => updateBg1In(1),
      onEnterBack: () => updateBg1In(1),
      onEnter: () => updateBg1In(0),
      onLeaveBack: () => updateBg1In(0)
    });

    ScrollTrigger.create({
      trigger: $features,
      start: 'top 50%',
      end: 'top -50%',
      onUpdate: (self) => {
        // Lottie 애니메이션 프레임을 progress에 맞게 이동
        if (bg1Anim && !prefersReducedMotion) {
          const totalFrames = bg1Anim.totalFrames;
          const targetFrame = Math.floor(self.progress * totalFrames);
          bg1Anim.goToAndStop(targetFrame, true);
        }
      },

    });

    // 핀 애니메이션
    updateBg1In(0);
    ScrollTrigger.create({
      trigger: $features,
      start: 'top top',
      end: 'bottom bottom',
      pin: $motion,
      pinSpacing: false
    });

    // Feature 1 콘텐츠 애니메이션
    const feature1ContentInTL = gsap.timeline({paused: true});
    const $feature1Txt = $feature1?.querySelector('.__title strong span');
    const $feature1Anims = $feature1?.querySelectorAll('[data-anim]');

    if ($feature1Txt && $feature1Anims) {
      feature1ContentInTL
          .to($feature1Txt, {
            yPercent: 0,
            duration: prefersReducedMotion ? 0 : 0.5,
            ease: prefersReducedMotion ? 'none' : 'power3.out'
          })
          .to($feature1Anims, {
            y: 0,
            opacity: 1,
            duration: prefersReducedMotion ? 0 : 0.5,
            ease: prefersReducedMotion ? 'none' : 'power3.out',
            stagger: prefersReducedMotion ? 0 : 0.1
          }, prefersReducedMotion ? 0 : 0.2);

      // Feature 1 콘텐츠 트리거
      const $feature1ContentTrigger = $homeFeatures.querySelector('.__feature1-content-in');
      if ($feature1ContentTrigger) {
        ScrollTrigger.create({
          trigger: $feature1ContentTrigger,
          start: 'top top',
          end: 'bottom top',
          onUpdate: (self) => {
            feature1ContentInTL.progress(self.progress);
            updateBg1In(1);
          },
          onLeave: () => {
            feature1ContentInTL.progress(1);
            updateBg1In(1);
          },
          onEnterBack: () => {
            feature1ContentInTL.progress(1);
            updateBg1In(1);
          },
          onEnter: () => {
            feature1ContentInTL.progress(0);
            updateBg1In(1);
          },
          onLeaveBack: () => {
            feature1ContentInTL.progress(0);
            updateBg1In(1);
          }
        });
      }
    }

    // Feature 2 배경 표시 애니메이션
    const feature2BgShowTL = gsap.timeline({paused: true})
        .to($bg2, {
          clipPath: 'inset(0% 0% 0% 0%)',
          duration: prefersReducedMotion ? 0 : 0.5,
          ease: 'none'
        })
        .to($bg2Img, {
          yPercent: 0,
          scale: 1,
          duration: prefersReducedMotion ? 0 : 0.5,
          ease: 'none'
        }, '<')
        .to($feature2, {
          yPercent: 0,
          duration: prefersReducedMotion ? 0 : 0.5,
          ease: 'none'
        }, '<');

    // Feature 2 배경 트리거
    const $feature2BgTrigger = $homeFeatures.querySelector('.__feature2-bg-show');
    if ($feature2BgTrigger) {
      ScrollTrigger.create({
        trigger: $feature2BgTrigger,
        start: 'top top',
        end: 'bottom top',
        onUpdate: (self) => {
          feature2BgShowTL.progress(self.progress);
        },
        onLeave: () => {
          feature2BgShowTL.progress(1);
          updateBg1In(1);
        },
        onEnterBack: () => {
          feature2BgShowTL.progress(1);
          updateBg1In(1);
        },
        onEnter: () => {
          feature2BgShowTL.progress(0);
          updateBg1In(1);
        },
        onLeaveBack: () => {
          feature2BgShowTL.progress(0);
          updateBg1In(1);
        }
      });
      ScrollTrigger.create({
        trigger: $feature2BgTrigger,
        start: 'top top',
        end: 'top -100%',
        onUpdate: (self) => {
          // Lottie 애니메이션 프레임을 progress에 맞게 이동 (0.35부터 시작)
          if (bg2Anim && !prefersReducedMotion) {
            const totalFrames = bg2Anim.totalFrames;
            const targetFrame = Math.floor(self.progress * totalFrames);
            bg2Anim.goToAndStop(Math.max(0, targetFrame), true);
          }
        },
      });
    }

    // Feature 2 콘텐츠 애니메이션
    const feature2ContentInTL = gsap.timeline({paused: true});
    const $feature2Txt = $feature2?.querySelector('.__title strong span');
    const $feature2Anims = $feature2?.querySelectorAll('[data-anim]');

    if ($feature2Txt && $feature2Anims) {
      feature2ContentInTL
          .to($feature2Txt, {
            yPercent: 0,
            duration: prefersReducedMotion ? 0 : 0.5,
            ease: prefersReducedMotion ? 'none' : 'power3.out'
          })
          .to($feature2Anims, {
            y: 0,
            opacity: 1,
            duration: prefersReducedMotion ? 0 : 0.5,
            ease: prefersReducedMotion ? 'none' : 'power3.out',
            stagger: prefersReducedMotion ? 0 : 0.1
          }, prefersReducedMotion ? 0 : 0.2);

      // Feature 2 콘텐츠 트리거
      const $feature2ContentTrigger = $homeFeatures.querySelector('.__feature2-content-in');
      if ($feature2ContentTrigger) {
        ScrollTrigger.create({
          trigger: $feature2ContentTrigger,
          start: 'top top',
          end: 'bottom top',
          onUpdate: (self) => feature2ContentInTL.progress(self.progress),
          onLeave: () => {
            feature2ContentInTL.progress(1);
            updateBg1In(1);
          },
          onEnterBack: () => {
            feature2ContentInTL.progress(1);
            updateBg1In(1);
          },
          onEnter: () => {
            feature2ContentInTL.progress(0);
            updateBg1In(1);
          },
          onLeaveBack: () => {
            feature2ContentInTL.progress(0);
            updateBg1In(1);
          }
        });
      }
    }

    // 성능 최적화된 배경 스크롤 함수
    const setBgY = (() => {
      let lastProgress = -1;

      return (progress) => {
        if (Math.abs(progress - lastProgress) < 0.001) return;
        lastProgress = progress;

        try {
          const yPercent = progress * 50;
          gsap.set([$bg1, $bg2], {
            yPercent,
          });
        } catch (error) {
          console.warn('Background scroll update failed:', error);
        }
      };
    })();

    // 최종 배경 스크롤 트리거
    ScrollTrigger.create({
      trigger: '#homeFeatures',
      start: 'bottom bottom',
      end: 'bottom top',
      onUpdate: (self) => setBgY(self.progress)
    });

  } catch (error) {
    console.warn('ScrollTrigger setup failed:', error);
  }

  // 정리 함수 (메모리 누수 방지)
  window.addEventListener('beforeunload', () => {
    try {
      bg1Anim?.destroy();
      bg2Anim?.destroy();
    } catch (error) {
      console.warn('Animation cleanup failed:', error);
    }
  });

});